'use client';

import { PureComponent } from 'react';
import { styled } from '@linaria/react';

import Paper from '@/components/Paper';
import Demo, { DemoRadioControl } from '@/components/Demo';

import Bezier from './Bezier';

class BezierController extends PureComponent {
  static defaultProps = {
    initialType: 'quadratic',
    allowToggle: false,
  };

  state = {
    viewBoxWidth: 1000,
    viewBoxHeight: 400,
    p1: this.props.p1 || [25, 200],
    p2: this.props.p2 || [500, 200],
    p3: this.props.p3 || [800, 200],
    p4: this.props.p4 || [975, 200],
    type: this.props.initialType,
    allowToggle: false,
  };

  handleUpdatePoint = (pointId, pointCoords) => {
    // HACK: Quadratic curves take P1, P2, and P4 (not P3).
    // This is to make transitioning between the two feel more natural.
    // Sadly, this means we have to patch that association when the quadratic
    // p4 moves.
    if (this.state.type === 'quadratic' && pointId === 'p3') {
      pointId = 'p4';
    }

    this.setState({ [pointId]: pointCoords });
  };

  render() {
    const { allowToggle } = this.props;
    const { viewBoxWidth, viewBoxHeight, p1, p2, p3, p4, type } =
      this.state;

    if (allowToggle) {
      return (
        <Demo
          initialValues={{
            type: this.props.initialType,
          }}
          controls={[
            <DemoRadioControl
              key="type"
              id="type"
              label="Type"
              options={[
                { value: 'quadratic', label: 'Quadratic' },
                { value: 'cubic', label: 'Cubic' },
              ]}
            />,
          ]}
        >
          {({ type }) => (
            <Bezier
              viewBoxWidth={viewBoxWidth}
              viewBoxHeight={viewBoxHeight}
              points={
                type === 'quadratic' ? [p1, p2, p4] : [p1, p2, p3, p4]
              }
              updatePoint={this.handleUpdatePoint}
            />
          )}
        </Demo>
      );
    }

    return (
      <Wrapper>
        <Bezier
          viewBoxWidth={viewBoxWidth}
          viewBoxHeight={viewBoxHeight}
          points={
            type === 'quadratic' ? [p1, p2, p4] : [p1, p2, p3, p4]
          }
          updatePoint={this.handleUpdatePoint}
        />
      </Wrapper>
    );
  }
}

const Wrapper = styled(Paper)`
  padding: 8px;
  margin-bottom: 40px;
  width: 100%;

  html[data-color-mode='light'] & {
    outline: 1px solid var(--color-gray-200);
  }
`;

const DemoWrapper = styled.div`
  width: 100%;
`;

const Controls = styled.div`
  padding: 20px;
`;

const RadioButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
`;

const Label = styled.label`
  flex: 1;
  text-align: center;
`;

export default BezierController;
